import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { createDivisionApi } from "../../../services/DivisonService";

const AddDivision = ({ handleAfterCreate }) => {
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: "" });
    const [errors, setErrors] = useState({});
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);

    const handleShow = () => setShowModal(true);
    const handleClose = () => {
        setShowModal(false);
        setFormData({ name: "" });
        setErrors({});
    };

    const validateForm = () => {
        let formErrors = {};
        if (!formData.name.trim()) formErrors.name = "Division name is required";
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                setIsSubmitLoading(true);
                const response = await createDivisionApi(formData);
                toast.success(response.data.message);
                handleAfterCreate(response.data.data); 
                handleClose(); 
            } catch (error) {
                toast.error(
                    error.response?.data?.message || "Something went wrong!"
                );
            } finally {
                setIsSubmitLoading(false);
            }
        }
    };

    return (
        <div>
            <button className="btn btn-primary" onClick={handleShow}>
                Add Division
            </button>

            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Division</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="divisionName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter division name"
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                isInvalid={!!errors.name}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.name}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <div className="text-end mt-3">
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                            <Button
                                variant="primary"
                                type="submit"
                                className="ms-2"
                                disabled={isSubmitLoading}
                            >
                                {isSubmitLoading ? "Submitting..." : "Submit"}
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default AddDivision;
